
import { Vue, Component } from "vue-property-decorator";
import CourseListing from "@/modules/courses/components/CourseListing.vue";

@Component({
  components: { CourseListing },
})
export default class AccountDashboard extends Vue {}
